import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest
} from '@angular/common/http';
import { Observable, from } from 'rxjs';
import * as Constants from '../../app/app.constants';
import { AuthService, AuthResult } from './auth.service';
import { switchMap, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MyInterceptorService implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (
      req.url.includes(Constants.API_BASE_URL + Constants.SOCIAL_AUTH_METADATA_BASE_URL) ||

      req.url.includes(Constants.API_BASE_URL + Constants.BASE_FAVORITE_URL) ||
      ((req.url.includes(Constants.API_BASE_URL + Constants.BASE_EVENT_URL) ||
        req.url.includes(Constants.API_BASE_URL + Constants.BASE_POI_URL)) &&
        req.method !== 'GET') ||
      (req.url.includes(Constants.API_BASE_URL + Constants.BASE_SOCIAL_URL + Constants.BASE_COMMENT_URL) &&
        !req.url.includes(Constants.LIST_COMMENT_URL)) ||
      (req.url.includes(Constants.API_BASE_URL + Constants.BASE_SOCIAL_URL + Constants.BASE_RATE_URL) &&
        !req.url.includes(Constants.LIST_RATE_URL)) ||
      req.url.includes(Constants.MEDIASERVER_UPLOAD_URL) ||
      (req.url.includes(Constants.MEDIASERVER_UPLOAD_MULTIPART_URL) ||
        req.url.includes(
          Constants.API_BASE_URL + Constants.BASE_MEDIA_URL + Constants.MEDIASERVER_DOWNLOAD_EDITOR_URL
        ))
    ) {
      return from(this.authService.getAuthentication()).pipe(
        switchMap((authResult: AuthResult) => {

          /*         console.log(
            `AuthResult pre request - AccessToken: ${authResult.accessToken}- RefreshToken: ${authResult.refreshToken} - ExpireDate: ${
              authResult.expireAt
            } - ExpireIn: ${authResult.expiresIn}`
          ); */
          req = req.clone({
            setHeaders: {
              Authorization: 'Bearer ' + authResult.accessToken
            }
          });

          if (
            req.url.includes(
              Constants.API_BASE_URL + Constants.BASE_MEDIA_URL +
                Constants.MEDIASERVER_DOWNLOAD_EDITOR_URL
            )
          ) {

            req = req.clone({
              setHeaders: {
                'Content-Type': 'image/jpeg',
                Authorization: 'Bearer ' + authResult.accessToken
              }
            });
            
          }
          return next.handle(req);
        }),
        catchError(error => {
          console.error(`Error: ${error}`);
          return next.handle(req);
        })
      );
    } else {
      return next.handle(req);
    }
  }

  constructor(public authService: AuthService) {}
}
